"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)({
  option: {
    display: 'flex',
    alignItems: 'center'
  },
  img: {
    marginRight: 8
  }
}, {
  name: 'AutoCompleteSelect'
});
exports.useStyles = useStyles;